import request from "./client";

export const getNominatimHealth = async () => {
  try {
    const resp = await request.get("/v1/search/nominatim/health");
    return { data: resp.body, error: null };
  } catch (e) {
    if (!e.response) return { data: null, error: e };
    return { data: null, error: e.response.body };
  }
};
